module.exports = __webpack_public_path__ + "static/media/gauth.25defe94.png";